import {ChangeDetectionStrategy, Component, HostBinding, OnInit} from '@angular/core';
import {FILTER_SUBTYPE, FILTER_TYPE} from '../services/config';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'similar-patients-analytics-view',
  templateUrl: './similar-patients-analytics-view.component.html',
  styleUrls: ['./similar-patients-analytics-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SimilarPatientsAnalyticsViewComponent implements OnInit {

  // need to set width of component --as is loaded--
  @HostBinding('style.width.%') width: number = 100;

  public readonly filterType = FILTER_TYPE;
  public readonly filterSubtype = FILTER_SUBTYPE;

  public isPatientContext: boolean = false;
  public patientId: string;
  public formData: any = {};
  public isFilterPanelOpen: boolean;
  //========================================================================================================

  constructor(private routerManagerService: RouterManagerService) { }
  //========================================================================================================

  ngOnInit() {
    this.patientId = this.routerManagerService.parameters.patientId;
    this.isPatientContext = (this.patientId && this.patientId.length > 0);
  }
  //========================================================================================================

  closeViewAndGoBack() {
    window.history.back();
  }
  //========================================================================================================

  onFormDataChanged(event) {
    this.formData = event.form;
  }
  //========================================================================================================

  public updatePanelState(event: boolean) {
    this.isFilterPanelOpen = event;
  }
  //========================================================================================================

}
